import { ActionNode, AutomationTaskNode, FlowNode } from "../types/nodes";

export const isProvider = (node: FlowNode): node is ActionNode => {
  return (
    node?.type === "action" &&
    node?.data.appliedAction.resourceType === "provider"
  );
};

export const isTransition = (node: FlowNode): node is ActionNode => {
  return (
    node?.type === "action" &&
    node?.data.appliedAction.resourceType === "transition"
  );
};

export const isAutomationTask = (
  node: FlowNode
): node is AutomationTaskNode => {
  return node?.type === "automationTask";
};
